import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginInfoProvider } from '../ev-dal/login-info.provider';
import { CommonDataSharedService } from './commonDataSharedService';
import { NotificationService } from './notification.service'

@Injectable({
  providedIn: 'root'
})
export class WebService {
  defaultOptions: any;
  currentUrl: any;
  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private loginInfo: LoginInfoProvider,
    private _commonDataSharedService: CommonDataSharedService
  ) {
    this.currentUrl = window.location.hostname === 'localhost' ? 'http://envision-test-caa.issportals.com/api' : `${window.location.origin}/api`;
  }

  // Create complete url by relative url
  _createUrl(url: string): string {
    return `${this.currentUrl}/api/` + url;
  };

  // NEEDFIX: delete after API changing (possibility get token from request headers)
  tokenize(data: any): any {
    data.token = this.loginInfo.token || '';

    return data;
  }

  // GET
  get(relativeUrl: string): Observable<any> {
    const url = this._createUrl(relativeUrl);

    return this.http.get(url);
  }

  // POST
  post(relativeUrl: string, data: any): Observable<any> {
    const url = this._createUrl(relativeUrl);

    //return this.http.post(url, data, options);
    return this.http.post(url, data).pipe(catchError((err: HttpErrorResponse) => this.catchError(err)));

  }

  catchError(errorObj: HttpErrorResponse) {
    if ((errorObj.error && errorObj.error.errorMessage || '').includes('Session Expired')) {
      this._commonDataSharedService.sessionExpired.next(true);
    }


    if (errorObj) {
        return observableThrowError(errorObj);
    }

  }
}
